import { pipe } from "fp-ts/function";
import * as L from "monocle-ts/Lens";
import { FeatureFlagControllerState } from "controllers/FeatureFlagController/FeatureFlagControllerState";

export const FeatureFlagL = pipe(
  L.id<FeatureFlagControllerState>(),
  L.prop("featureFlags")
);
